<template>
  <el-card class="box-card main-card">
    <el-button v-if="$route.query.userId" size="mini" class="pxy-primary return-button" style="margin-right: 10px;" @click="$router.go(-1)">返回</el-button>
    <el-tabs v-model="activeTab">
      <el-tab-pane label="流水账单" name="waterBills">
        <el-form class="search-form" ref="form" :model="searchForm" v-if="!$route.query.userId" >
          <el-form-item label="">
            <el-select v-model="searchForm.accountingPeriod"
                       clearable placeholder="账期" @change="searchFn" style="width: 120px">
              <el-option
                v-for="(item,index) in accountingPeriods"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" label-width="20px">
            <el-select v-model="searchForm.chargeType" clearable placeholder="计费模式" style="width: 120px"  @change="searchFn">
              <el-option :key=1 label="包年/包月" :value=1>包年/包月</el-option>
              <el-option :key=2 label="按需" :value=2>按需</el-option>
            </el-select>
          </el-form-item>
         <!-- <el-form-item label="" label-width="20px">
            <el-select v-model="searchForm.expType" clearable placeholder="账单类型" style="width: 150px">
              <el-option :key=1 label="消费-新购" :value=1>消费-新购</el-option>
              <el-option :key=2 label="消费-变更" :value=2>消费-变更</el-option>
              <el-option :key=3 label="消费-续订" :value=3>消费-续订</el-option>
              <el-option :key=4 label="消费-使用" :value=4>消费-使用</el-option>
              <el-option :key=5 label="消费-按需计费" :value=5>消费-按需计费</el-option>
            </el-select>
          </el-form-item>-->
          <el-button :loading="downloadLoading" style="margin:0 0 15px 15px;" type="primary" size="small" icon="el-icon-document" @click="handleDownload">
            导出
          </el-button>
        </el-form>
        <el-row v-if="$route.query.userId" style="margin-bottom: 20px;">
          <span>用户名称：</span>
          <el-tag effect="plain">{{$route.query.userName}}</el-tag>
        </el-row>
        <template>
          <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column  type="expand">
              <template slot-scope="props">
                <!--             <span>{{props.rows.pocOrderDetails}}</span>-->
                <el-table
                  :data="props.row.ofcConsumeDetailList"
                  style="width: 100%"
                  border
                  height="250">
                  <el-table-column
                    prop="orderType"
                    label="产品名称">
                    <template  slot-scope="scope">
                      {{scope.row.orderType | formatOrderType}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="itemName"
                    label="明细">
                  </el-table-column>
                  <el-table-column
                    prop="objId"
                    label="实例Id">
                  </el-table-column>
                  <el-table-column
                    label="单价"
                  >
                    <template  slot-scope="scope">
                      {{scope.row.price }} &nbsp; {{scope.row.priceUnit }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="消费时长">
                    <template  slot-scope="scope">
                      {{scope.row.consumeDuration }}分钟
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="数量">
                    <template  slot-scope="scope">
                      {{scope.row.cnt }} &nbsp; {{scope.row.cntUnit }}
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="amount"
                    label="总价">
                  </el-table-column>

                  <el-table-column
                    prop="discount"
                    label="优惠金额">
                  </el-table-column>
                  <el-table-column
                    prop="amountDue"
                    label="应付金额">
                  </el-table-column>

                  <el-table-column
                    prop="startDate"
                    label="开始时间">
                    <template  slot-scope="scope">
                      {{scope.row.startDate | formatDateTime}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="startDate"
                    label="结束时间">
                    <template  slot-scope="scope">
                      {{scope.row.endDate | formatDateTime}}
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              prop="accountingPeriod"
              label="账期">
            </el-table-column>
            <el-table-column
              prop="orderId"
              label="订单id">
            </el-table-column>
            <el-table-column
              prop="orderType"
              label="产品名称">
              <template  slot-scope="scope">
                {{scope.row.orderType | formatOrderType}}
              </template>
            </el-table-column>
            <el-table-column label="资源ID">

              <template slot-scope="scope">
                <span> {{scope.row.resourceId}}</span>
              </template>
            </el-table-column>
            <el-table-column label="资源实例">

              <template slot-scope="scope">
                <span> {{scope.row.resourceName}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="计费模式">
              <template slot-scope="scope">
                {{scope.row.chargeType | formatChargeType}}
              </template>
            </el-table-column>
            <el-table-column
              label="账单类型">
              <template slot-scope="scope">
                {{scope.row.expType | formatBillType}}
              </template>
            </el-table-column>

            <el-table-column
              prop="createDate"
              label="消费时间" width="160px">
              <template slot-scope="scope">
                {{scope.row.startDate | formatDateTime}}至
                {{scope.row.endDate | formatDateTime}}
              </template>
            </el-table-column>

            <el-table-column
              prop="consumeDuration"
              label="使用时长">
              <template slot-scope="scope">
                {{scope.row.consumeDuration }}分钟
              </template>
            </el-table-column>

            <el-table-column
              prop="amount"
              label="原价">
            </el-table-column>

            <el-table-column
              prop="discount"
              label="优惠金额">
            </el-table-column>

            <el-table-column
              prop="amountDue"
              label="应付金额">
            </el-table-column>

            <el-table-column
              prop="cashPayAmount"
              label="现金支付金额">
            </el-table-column>

            <el-table-column
              prop="voucherPayAmount"
              label="代金券支付金额">
            </el-table-column>

            <el-table-column
              label="创建时间">
              <template slot-scope="scope">
                {{scope.row.createDate | formatDate}}
              </template>
            </el-table-column>

          </el-table>
        </template>
<!--        <PageComponent :currentPage="pageObj.currentPage" :total="pageObj.total" :pageSize="pageObj.pageSize" @handlePageChange="handlePageChange"></PageComponent>-->
        <PageComponent ref="pageInfo"></PageComponent>
      </el-tab-pane>
      <!--      <el-tab-pane label="汇总" name="second">汇总</el-tab-pane> -->
    </el-tabs>

  </el-card>

</template>

<script>
  import PageComponent from '@/components/pageInfo/PageComponent'
  import {Message} from "element-ui";

  export default {
    components: {PageComponent},
    data() {
      return {
        activeTab:'waterBills',
        searchForm: {
          accountingPeriod: '',
          //chargeType，包年包月（1），按量付费（2）
          chargeType: 2,
          //expType 账单类型:消费-新购(1)、消费-变更(2)、消费-续订(3)、消费-使用(4)、消费-按需计费(5)
          expType: 5
        },
        accountingPeriods: [],
        tableData:[],
        pageObj: {
          currentPage: 1,
          total: '0',
          pageSize: 10
        },
        downloadLoading: false,
      }
    },
    beforeCreate(){},
    created() {
      this.getLatest20Months();
    },
    methods: {
      getLatest20Months() {
        //创建现在的时间
        let date = new Date();
        //获取年
        let year = date.getFullYear();
        //获取月
        let mon = date.getMonth() + 1;
        for (let i = 0; i < 20; i++) {
          if (mon <= 0) {
            year = year - 1;
            mon = mon + 12;
          }
          if (mon < 10) {
            mon = "0" + mon;
          }
          this.accountingPeriods[i] = year + "-" + mon ;
          mon = mon - 1;
        }
        this.searchForm.accountingPeriod =  this.accountingPeriods[0];
      },
      getBills: function () {
        var params = {};
     /*   params.page = this.pageObj.currentPage;
        params.pageSize = this.pageObj.pageSize;*/
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        console.log(params);
        if(this.searchForm.accountingPeriod != ''){
          params.accountingPeriod = this.searchForm.accountingPeriod;
        }
        if(this.searchForm.chargeType != ''){
          params.chargeType = this.searchForm.chargeType;
        }
        this.getRequest('/ofcConsumeLog/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.tableData = resp.data.result.records;
             // this.pageObj.total = resp.data.result.total;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      // 账单查询 - （用户管理菜单页跳转过来）
      getUserIdBills() {
        let params = {
          userId: this.$route.query.userId,
         /* page: this.pageObj.currentPage,
          pageSize: this.pageObj.pageSize*/
        }
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        console.log(params);
        this.getRequest('/ofcConsumeLog/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {

              this.tableData = resp.data.result.records;
              console.log(resp.data.result)
             // this.pageObj.total = resp.data.result.total;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      //筛选条件更改时
      searchFn() {
        var queryStr = JSON.parse(JSON.stringify(this.$route.query));
        queryStr.page = 1;
        this.$router.push({query: queryStr});
        this.getBills();
      },

      fileDownload(data, fileName) {
        const blob = new Blob([data], {
          type: 'application/octet-stream'
        })
        const filename = fileName || 'filename.xlsx'
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(blob, filename)
        } else {
          let blobURL = window.URL.createObjectURL(blob)
          let tempLink = document.createElement('a')
          tempLink.style.display = 'none'
          tempLink.href = blobURL
          tempLink.setAttribute('download', filename)
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank')
          }
          document.body.appendChild(tempLink)
          tempLink.click()
          document.body.removeChild(tempLink)
          window.URL.revokeObjectURL(blobURL)
        }
      },
      handleDownload() {
        this.downloadLoading = true
        this.downloadRequest('/ofcConsumeLog/download?accountingPeriod='+this.searchForm.accountingPeriod).then(resp => {
          const filename = decodeURI(resp.headers['content-disposition'].split(';')[1].split('=')[1])
          this.fileDownload(resp.data, filename);
          this.downloadLoading = false
        })
      },
    },
    mounted: function () {
      if(this.$route.query.userId){ // 账单查询 - （用户管理菜单页跳转过来）
        this.getUserIdBills();
        this.$refs.pageInfo.initPagenator(this.getUserIdBills, null);
      } else {
        this.getBills()
        this.$refs.pageInfo.initPagenator(this.getBills, null);
      }

    },
    beforeDestroy() {

    },
  }
</script>

